@if (renderAsButton()) {
	<button
		type="button"
		class="ara-generic-chip ara-generic-chip--clickable"
		[class.ara-generic-chip--highlighted]="highlighted()"
		[attr.data-tone]="color() ? null : tone()"
		[attr.data-appearance]="appearance() === 'soft' ? null : appearance()"
		[disabled]="disabled()"
		(click)="$event.stopPropagation(); chipClick.emit()">
		@if (appearance() === 'add') {
			<!-- Inline-SVG wie beim Entfernen-X: der Chip bleibt frei von einer MatIcon-Abhängigkeit. -->
			<svg class="ara-generic-chip__add" viewBox="0 0 24 24" aria-hidden="true">
				<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none" />
			</svg>
		}
		@if (label()) {
			<span class="ara-generic-chip__label">{{ label() }}</span>
		}
		<ng-content />
	</button>
} @else {
	<span
		class="ara-generic-chip"
		[class.ara-generic-chip--highlighted]="highlighted()"
		[attr.data-tone]="color() ? null : tone()"
		[attr.data-appearance]="appearance() === 'soft' ? null : appearance()">
		<ng-content />
		@if (label()) {
			<span class="ara-generic-chip__label">{{ label() }}</span>
		}
		@if (removable()) {
			<button type="button" class="ara-generic-chip__remove" [attr.aria-label]="removeLabel() || null" (click)="$event.stopPropagation(); removed.emit()">
				<svg viewBox="0 0 24 24" aria-hidden="true">
					<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none" />
				</svg>
			</button>
		}
	</span>
}
